import Api from '@common/services/api';

export const toggleFavourite = async (orgId: string, conversationId: string, shouldFavourite: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/${shouldFavourite ? 'favorite' : 'unfavorite'}`);
};
